import { FC } from 'react';

import { BasketBlockFullHead } from '@/components/modules/basket-page/basket-block-full-head';
import { BasketIsAllowedBlock } from '@/components/modules/basket-page/basket-is-allowed-block';
import { BasketItemProduct } from '@/components/modules/basket-page/basket-item-product';
import { StyledBasketFullWrapper } from '@/components/modules/basket-page/styled';
import { CalculatorContext, useCalculationInitStateContext } from '@/components/modules/caclulator';
import { TVariantsCreditProducts } from '@/components/modules/caclulator/types';

import { TRentProduct } from '@/entities/product';

type TProps = {
    products: TRentProduct[];
    variantsCreditProducts: TVariantsCreditProducts;
};

export const BasketBlockFull: FC<TProps> = ({ products, variantsCreditProducts }) => {
    const contextState = useCalculationInitStateContext();

    return (
        <StyledBasketFullWrapper>
            <BasketBlockFullHead count={products.length} />
            <BasketIsAllowedBlock />
            {products.map((item, index) => {
                return (
                    <CalculatorContext.Provider value={contextState} key={`product-basket-${index.toString()}`}>
                        <BasketItemProduct product={item} variantsCreditProducts={variantsCreditProducts} />
                    </CalculatorContext.Provider>
                );
            })}
        </StyledBasketFullWrapper>
    );
};
